// TODO: SkedCaption is packed with business logic, so IMO must be
// in the feautres/sked-caption rather then ui/SkedCaption
export { default as SkedCaption } from "./SkedCaption";
export {
  getSkedCaptionAutocomplete,
  useSkedCaptionAutocomplete,
} from "./SkedCaptionAutocomplete";
